"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MAP_LEGENDS = void 0;
var DEFAULT_MAP_LEGENDS;
(function (DEFAULT_MAP_LEGENDS) {
    DEFAULT_MAP_LEGENDS["TYPE"] = "_type";
    DEFAULT_MAP_LEGENDS["VISIT_DAY"] = "_visit_day";
    DEFAULT_MAP_LEGENDS["ACTIVITY_DAY"] = "_activity_day";
    DEFAULT_MAP_LEGENDS["USERS"] = "_users";
    DEFAULT_MAP_LEGENDS["OWNERS"] = "_owners";
    DEFAULT_MAP_LEGENDS["TEAMS"] = "_teams";
})(DEFAULT_MAP_LEGENDS || (exports.DEFAULT_MAP_LEGENDS = DEFAULT_MAP_LEGENDS = {}));
